/*
 * Validate forms
 */

import poly from './poly';
import niceScroll from './niceScroll';

const { $ } = poly;

const SETTINGS = {
  checkOneCheckbox: 'Plaese select',
  empty: 'Required field',
  invalidEmail: 'Invalid email address',
  invalidPhone: 'Please enter a valid telephone number',
  notPoBox: 'Sorry, we cannot ship to p.o. boxes',
  tooLong: chars => `Please enter up to ${chars} chars`,
  tooShort: chars => `Please enter at least ${chars} chars`,
  validateMatch: 'Values must match',
};

const CLASSNAME_ERROR_STATE = 'form--error';
const CLASSNAME_ERROR_MSG = 'form__error-msg';
const DOT = '.';
const SELECTOR_FORM = '.js-formValidation';
const SELECTORS = 'input, select, textarea';
// data attribute the validate the value against a different element, ref. id
const SELECTOR_MATCH_EL = 'data-validate-match';

/* eslint-disable no-useless-escape, no-control-regex */
const validateEmail = function validateFormEmail(email) {
  return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email); // eslint-disable-line max-len
};
/* eslint-enable no-useless-escape, no-control-regex */

const validatePhone = function validateFormPhone(phone) {
  return /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/i.test(phone); // eslint-disable-line max-len
};

const getRadioValue = function getRadioInputValue(elName) {
  const radios = document.querySelectorAll(`input[name='${elName}']`);
  const checkedRadio = Array.prototype.find.call(radios, radio => radio.checked);

  if (checkedRadio && checkedRadio.value) {
    return checkedRadio.value;
  }
  return false;
};

const getInputList = function getFormInputList(form) {
  const formElNodes = form.querySelectorAll(SELECTORS);
  const formEls = [];

  if (formElNodes) {
    $(formElNodes).each((formEl) => {
      const maxlength = formEl.getAttribute('maxlength') * 1 || 0;
      const minlength = formEl.getAttribute('minlength') * 1 || 0;
      const tag = formEl.tagName.toLowerCase();
      const type = (tag === 'select') ? 'select' : (formEl.getAttribute('type') || 'text');
      const name = formEl.getAttribute('name');
      const validateMatch = formEl.getAttribute(SELECTOR_MATCH_EL) || false;
      const pseudoRequired = formEl.getAttribute('data-required');

      if (formEl.required || pseudoRequired) {
        formEls.push({
          form,
          name,
          tag,
          type,
          maxlength,
          minlength,
          validateMatch,
          el: formEl,
          required: formEl.required,
        });
      }
    });
  }
  return formEls;
};

const addFormError = function addFormValidationError(_formEl, errorMessage) {
  const formEl = _formEl;
  let errorEl = formEl.el.parentNode.querySelector(`.${CLASSNAME_ERROR_MSG}`);

  $(formEl.el).addClass(CLASSNAME_ERROR_STATE);
  formEl.error = true;
  if (errorEl) {
    errorEl.parentNode.removeChild(errorEl);
  }
  errorEl = document.createElement('div');
  errorEl.setAttribute('aria-live', 'polite');
  $(errorEl).addClass(CLASSNAME_ERROR_MSG);
  errorEl.innerHTML = errorMessage;
  formEl.el.parentNode.appendChild(errorEl);

  return formEl;
};

const isChecked = function isFormCheckboxChecked(field) {
  const form = field.closest('form');
  const name = field.getAttribute('name');

  return [].some.call(form.querySelectorAll(`input[name="${name}"]`), input => input.checked);
};

const validate = function validateForm(form) {
  let isValid = true;

  const formEls = getInputList(form);

  // Refactor into a switch or something cleaner
  if (!formEls) {
    return true;
  }

  formEls.forEach((_formEl) => {
    let formEl = _formEl;

    let val = '';
    const errorEl = formEl.el.parentNode.querySelector(`.${CLASSNAME_ERROR_MSG}`);
    const inputName = (
      formEl.el.getAttribute('data-name')
      || formEl.el.getAttribute('aria-label')
      || formEl.el.getAttribute('placeholder')
    );

    if (formEl.type === 'select') {
      val = formEl.el.options[formEl.el.selectedIndex].value;
    } else if (formEl.type === 'checkbox') {
      // if (formEl.el.checked) {
      val = formEl.el.value;
      // }
    } else if (formEl.type === 'radio' && formEl.name) {
      val = getRadioValue(formEl.name);
    } else {
      val = formEl.el.value || '';
    }

    val = val.trim();
    // Assinged by toggleForms.js
    if (formEl.el.getAttribute('aria-hidden')) {
      // Skip empty elements
    } else if (formEl.type === 'checkbox' && formEl.required && !isChecked(formEl.el)) {
      formEl = addFormError(formEl, SETTINGS.checkOneCheckbox);
      isValid = false;
    } else if (!val && formEl.required) {
      if (formEl.el.getAttribute('placeholder')) {
        formEl = addFormError(formEl, `Please enter ${formEl.el.getAttribute('data-error-name') || inputName}`);
      } else {
        formEl = addFormError(formEl, SETTINGS.empty);
      }
      isValid = false;
    } else if (val && formEl.type === 'email' && !validateEmail(val)) {
      formEl = addFormError(formEl, SETTINGS.invalidEmail);
      isValid = false;
    } else if (val && formEl.el.getAttribute('data-validation-type') === 'phone' && !validatePhone(val)) {
      formEl = addFormError(formEl, SETTINGS.invalidPhone);
      isValid = false;
    } else if (val && formEl.maxlength > 0 && val.length > formEl.maxlength) {
      formEl = addFormError(formEl, SETTINGS.tooLong(formEl.maxlength));
      isValid = false;
    } else if (val && formEl.minlength > 0 && val.length < formEl.minlength) {
      formEl = addFormError(formEl, SETTINGS.tooShort(formEl.minlength));
      isValid = false;
    } else if (
      val
      && formEl.validateMatch
      && document.getElementById(formEl.validateMatch)
      && document.getElementById(formEl.validateMatch).value !== val
    ) {
      formEl = addFormError(formEl, SETTINGS.validateMatch);
      isValid = false;
    } else {
      // Is valid
      $(formEl.el).removeClass(CLASSNAME_ERROR_STATE);
      formEl.error = false;

      if (errorEl) {
        errorEl.parentNode.removeChild(errorEl);
      }
    }
  });

  return isValid;
};

const scrollToFirstError = function scrollToFirstFormError(el) {
  if (!el) {
    return;
  }
  const elFirstError = el.querySelector(DOT + CLASSNAME_ERROR_STATE);
  if (!elFirstError) {
    return;
  }
  const gutter = 160;
  const scrollY = window.scrollY || window.pageYOffset;
  const top = elFirstError.getBoundingClientRect().top + scrollY - gutter;
  niceScroll.scrollTo({
    y: top,
    speed: 0.8,
  });
};

const onSubmit = function onFormSubmit(callback, shouldScroll) {
  return (ev) => {
    if (validate(ev.currentTarget)) {
      if (typeof callback === 'function') {
        callback(ev.currentTarget, ev);
      }
    } else {
      ev.preventDefault();
      if (shouldScroll) {
        scrollToFirstError(ev.currentTarget);
      }
    }
  };
};

const onInputChange = function onFormInputChange(ev) {
  const input = ev.target;
  const form = input.closest('form');
  if (form && $(input).hasClass(CLASSNAME_ERROR_STATE)) {
    validate(form);
  }
};

const bindChange = function bindFormInputChange(form) {
  const formEls = getInputList(form);
  if (formEls) {
    $(formEls).each((formEl) => {
      // TODO: review
      formEl.el.removeEventListener('change', onInputChange);
      formEl.el.addEventListener('change', onInputChange);
      formEl.el.removeEventListener('keyup', onInputChange);
      formEl.el.addEventListener('keyup', onInputChange);
    });
  }
};

const bind = function bindValidation(form, callback = false, shouldScroll = true) {
  // disable validation
  form.setAttribute('novalidate', 'novalidate');

  // TODO: review
  form.removeEventListener('submit', onSubmit(callback, shouldScroll));
  form.addEventListener('submit', onSubmit(callback, shouldScroll));

  bindChange(form);
};

const init = function initFormValidation(shouldScroll = true) {
  const forms = document.querySelectorAll(SELECTOR_FORM);
  if (forms && forms.length) {
    [].forEach.call(forms, (_form) => {
      const form = _form.tagName === 'FORM' ? _form : _form.querySelector('form');
      if (form) {
        bind(form, false, shouldScroll);
      }
    });
  }
};

const destroy = function destroyFormValidation() {
};

export default {
  bind,
  bindChange,
  destroy,
  init,
  onSubmit,
  scrollToFirstError,
  validate,
  validateEmail,
};
